<template>
	<div class="user-center-container">
		<div class="user-center-content">
			<div class="form-header">
				<h3 class="form-title">申请开票</h3>
			</div>

			<!-- 查询待开发票的订单 -->
			<data-table
				:table-data="orderList"
				:column="columns"
				:page-options="pageOptions"
				:border="true"
				:loading="loading"
				:selection="true"
				:reserve-selection="true"
				:row-keys="handleRowKeys"
				@selectionChange="handleSelectDataChange"
				@page-change="handlePaginationChange"
			></data-table>

			<!-- 底部操作栏 -->
			<div class="invoice-footer">
				<div class="selected-info">
					<span>
						已选择
						<em>{{ selectedCount }}</em>
						笔订单，合计：
					</span>
					<span class="total-amount">¥{{ totalAmount.toFixed(2) }}</span>
				</div>
				<el-button type="primary" :disabled="selectedCount === 0" @click="handleApplyInvoice">申请开票</el-button>
			</div>
		</div>

		<!-- 发票信息填写弹窗 -->
		<jr-dialog :visible.sync="editInvoiceVisible" :show-btn="false" @close="handleCloseEditInvoice">
			<template slot="title">
				<!-- 自定义弹窗标题 -->
				<h4 class="model-title">
					<span>发票填写</span>
				</h4>
			</template>
			<template slot="content">
				<div class="form-content">
					<el-form ref="invoiceForm" :model="invoiceForm" :rules="rules" label-width="140px">
						<el-form-item label="开票类型：" prop="invoiceType" class="form-item">
							<el-radio-group v-model="invoiceForm.invoiceType">
								<el-radio label="0">增值税普通发票</el-radio>
								<el-radio label="1">增值税专用发票</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="抬头类型：" prop="headType" class="form-item">
							<el-radio-group v-model="invoiceForm.headType">
								<el-radio label="0">企业</el-radio>
								<el-radio label="1">个人</el-radio>
							</el-radio-group>
						</el-form-item>
						<template v-if="invoiceForm.headType === '0'">
							<el-form-item label="企业名称：" prop="taxpayer" class="form-item">
								<el-input v-model="invoiceForm.taxpayer" placeholder="请输入企业名称"></el-input>
							</el-form-item>
							<el-form-item label="纳税人识别号：" prop="taxpayerCode" class="form-item">
								<el-input v-model="invoiceForm.taxpayerCode" placeholder="请输入纳税人识别号"></el-input>
							</el-form-item>
							<el-form-item label="企业注册地址：" prop="companyAddr" class="form-item">
								<el-input v-model="invoiceForm.companyAddr" placeholder="请输入企业注册地址"></el-input>
							</el-form-item>
							<el-form-item label="企业注册电话：" prop="companyPhone" class="form-item">
								<el-input v-model="invoiceForm.companyPhone" placeholder="请输入企业注册电话"></el-input>
							</el-form-item>
							<el-form-item label="开户银行：" prop="bankName" class="form-item">
								<el-input v-model="invoiceForm.bankName" placeholder="请输入开户银行"></el-input>
							</el-form-item>
							<el-form-item label="银行账号：" prop="bankCode" class="form-item">
								<el-input v-model="invoiceForm.bankCode" placeholder="请输入银行账号"></el-input>
							</el-form-item>
						</template>
						<template v-else-if="invoiceForm.headType === '1'">
							<el-form-item label="发票抬头：" prop="taxpayer" class="form-item">
								<el-input v-model="invoiceForm.taxpayer" placeholder="请输入个人或姓名"></el-input>
							</el-form-item>
						</template>

						<div class="form-tips">
							<p>
								提示：请按照电子商务法及发票管理办法等相关规定填写发票信息，若因填写无效信息或非法信息等造成包括但不限于无法成功开具发票等后果或法律责任，由您自行承担。
							</p>
						</div>
					</el-form>

					<div class="form-button-group">
						<el-button
							:loading="submitLoading"
							type="primary"
							class="form-button form-button--default"
							@click="handleCloseEditInvoice"
						>
							取消
						</el-button>
						<el-button
							:loading="submitLoading"
							type="primary"
							class="form-button form-button--primary"
							@click="handleSubmitInvoiceInfo"
						>
							提交
						</el-button>
					</div>
				</div>
			</template>
		</jr-dialog>
	</div>
</template>

<script>
	import DataTable from '@/components/JrTable/DataTable.vue'
	import JrDialog from '@/components/Dialog'
	import { queryOrderRecordInvoice, saveApplyInvoiceInfo } from '@/api/memberBenefit/index'
	import { getUserInfo } from '@/api/userCenter/index'

	// 申请开票
	export default {
		name: 'OrderSelect',
		components: {
			DataTable,
			JrDialog
		},
		props: {},
		data() {
			return {
				// 加载状态
				loading: false,
				columns: [
					{ label: '订单编号', prop: 'orderCode', align: 'center' },
					{ label: '套餐名称', prop: 'setMealName', align: 'center' },
					{ label: '订单时间', prop: 'createTime', width: '180', align: 'center' },
					{ label: '实付款', prop: 'actualPayment', align: 'center' }
				],
				// 订单列表
				orderList: [],
				// 分页配置
				pageOptions: {
					limit: 10,
					page: 1,
					total: 0
				},
				// 非多个禁用
				multiple: true,
				// 选中的订单数据
				selectedOrders: [],
				// 所选中的订单ID集合
				selectedOrderIds: '',
				// 已选择的订单金额
				totalAmount: 0,
				// 发票填写弹窗
				editInvoiceVisible: false,
				// 提交加载状态
				submitLoading: false,
				// 发票抬头信息
				invoiceForm: {
					// 开票类型（0增值税普通发票，1增值税专用发票）
					invoiceType: '',
					// 抬头类型（0企业，1个人）
					headType: '',
					// 企业名称
					taxpayer: '',
					// 纳税人识别号
					taxpayerCode: '',
					// 企业注册地址
					companyAddr: '',
					// 企业注册电话
					companyPhone: '',
					// 开户银行
					bankName: '',
					// 银行账号
					bankCode: ''
				},
				rules: {
					invoiceType: [{ required: true, message: '请选择开票类型', trigger: 'change' }],
					headType: [{ required: true, message: '请选择抬头类型', trigger: 'change' }],
					taxpayer: [{ required: true, message: '请输入纳税人名称', trigger: 'blur' }],
					taxpayerCode: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }]
				}
			}
		},
		computed: {
			// 已选择的订单数量
			selectedCount() {
				return this.selectedOrderIds.length
			}
		},
		watch: {},
		created() {},
		mounted() {
			this.getOrderList()
		},
		methods: {
			// 获取订单列表
			async getOrderList() {
				this.loading = true

				const params = {
					page: this.pageOptions.page,
					size: this.pageOptions.limit,
					...this.queryParams
				}

				const { data } = await queryOrderRecordInvoice(params)

				if (data && data.records) {
					this.orderList = data.records
					this.pageOptions.total = data.total || 0

					// 数据加载完成后恢复选中状态
					if (this.selectedOrders.length) {
						this.orderList = data.map(item => {
							item._selected = this.selectedOrders.some(sel => sel.id === item.id)
							return item
						})
					}
				} else {
					this.orderList = []
					this.pageOptions.total = 0
				}
				this.loading = false
			},

			handleRowKeys(row) {
				return row.id
			},

			// 选中回调
			handleSelectDataChange(selection) {
				// 更新当前页的选中状态
				this.orderList.forEach(item => {
					item._selected = selection.some(sel => sel.id === item.id)
				})

				// 更新全局选中列表
				selection.forEach(item => {
					const index = this.selectedOrders.findIndex(sel => sel.id === item.id)
					if (index === -1) {
						// 添加新选中项
						this.selectedOrders.push({ ...item })
					} else {
						// 更新已存在项（可能数据有变化）
						this.selectedOrders[index] = { ...item }
					}
				})

				// 移除取消选中的项
				this.selectedOrders = this.selectedOrders.filter(sel => selection.some(item => item.id === sel.id))

				// 计算总价
				this.totalAmount = this.selectedOrders.reduce((sum, order) => {
					return sum + (parseFloat(order.actualPayment) || 0)
				}, 0)

				this.selectedOrderIds = selection.map(item => item.id)
				this.multiple = !selection.length
			},

			// 分页变化
			async handlePaginationChange(pager) {
				const { page, limit } = pager
				this.pageOptions.page = page
				this.pageOptions.limit = limit

				// 记录当前页的选中状态
				this.orderList.forEach(item => {
					if (item._selected) {
						const existing = this.selectedOrders.find(sel => sel.id === item.id)
						if (!existing) {
							this.selectedOrders.push({ ...item })
						}
					}
				})

				await this.getOrderList()
			},

			// 申请开票
			handleApplyInvoice() {
				if (this.selectedOrderIds.length === 0) {
					this.$message.warning('请至少选择一个订单')
					return
				}

				this.handleQueryMyInvoiceHeadInfo()

				// 打开发票信息弹窗
				this.editInvoiceVisible = true
			},

			// 查询我的发票抬头信息
			async handleQueryMyInvoiceHeadInfo() {
				const params = {
					// 仅获取iuserinfo表主要返回开票配置信息
					type: 'invoiceInfo'
				}
				const { data } = await getUserInfo(params)

				if (data) {
					this.invoiceForm = {
						invoiceType: data.invoiceType,
						headType: data.headType,
						taxpayer: data.taxpayer,
						taxpayerCode: data.taxpayerCode,
						companyAddr: data.companyAddr,
						companyPhone: data.companyPhone,
						bankName: data.bankName,
						bankCode: data.bankCode
					}
				}
			},

			// 关闭发票信息填写弹窗
			handleCloseEditInvoice() {
				this.editInvoiceVisible = false
			},

			// 申请开票信息提交
			handleSubmitInvoiceInfo() {
				this.$refs.invoiceForm.validate(valid => {
					if (valid) {
						this.submitLoading = true
						const params = {
							orderIds: this.selectedOrderIds,
							dynamicInvoiceRecord: {
								...this.invoiceForm
							}
						}

						console.log('params:', params)

						saveApplyInvoiceInfo(params)
							.then(response => {
								this.submitLoading = false
								this.$modal.msgSuccess('申请开票成功')
								this.handleCloseEditInvoice()
								// 再次查询，刷新待开发票的订单信息
								this.getOrderList()
							})
							.catch(() => {
								this.submitLoading = false
							})
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/views/user/styles/user-center.scss';
	@import '~@/styles/element-reset.scss';

	// .order-list-container {
	// 	background: #fff;
	// 	border-radius: 8px;
	// 	padding: 20px;
	// 	margin-bottom: 20px;
	// 	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

	// 	.table-header {
	// 		display: flex;
	// 		align-items: center;
	// 		padding: 15px 20px;
	// 		background-color: #f5f7fa;
	// 		border-radius: 4px;
	// 		font-weight: bold;
	// 		color: #606266;
	// 		border-bottom: 1px solid #ebeef5;

	// 		.header-item {
	// 			flex: 1;
	// 			text-align: center;

	// 			// 最后一列金额列给它设置固定宽度
	// 			&:last-of-type {
	// 				flex: 0 0 110px;
	// 			}
	// 		}
	// 	}

	// 	.table-body {
	// 		.table-row {
	// 			display: flex;
	// 			align-items: center;
	// 			padding: 15px 20px;
	// 			border-bottom: 1px solid #ebeef5;
	// 			transition: background-color 0.3s;

	// 			&:hover {
	// 				background-color: #fafafa;
	// 				transform: translateY(-1px);
	// 				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
	// 			}

	// 			&:last-child {
	// 				border-bottom: none;
	// 			}

	// 			.row-item {
	// 				flex: 1;
	// 				text-align: center;
	// 				color: #606266;

	// 				&.order-code {
	// 					color: #409eff;
	// 					cursor: pointer;
	// 				}

	// 				&.amount {
	// 					color: #f56c6c;
	// 					font-weight: 500;
	// 					flex: 0 0 110px;
	// 				}
	// 			}
	// 		}
	// 	}
	// }

	.invoice-footer {
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 15px 30px;
		background: #fff;
		box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);

		.selected-info {
			font-size: 14px;
			color: #606266;

			em {
				font-style: normal;
				color: #409eff;
				font-weight: bold;
				margin: 0 5px;
			}

			.total-amount {
				font-size: 20px;
				color: #f56c6c;
				font-weight: bold;
				margin-left: 10px;
			}
		}

		.el-button {
			padding: 12px 25px;
			font-size: 16px;
		}
	}

	// 重置表单样式
	.form-content {
		.form-item {
			::v-deep {
				.el-input {
					input {
						padding: 0 15px 0 15px;
					}
				}
			}
		}
	}
</style>
